export default __webpack_public_path__ + "static/media/caret-down.9219b63f.svg";